import { configureStore } from '@reduxjs/toolkit';
import reducer from './rootReducer';
var store = configureStore({
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActionPaths: ['payload.handleProfileClick', 'payload.config'],
                ignoredPaths: ['appConfig.handleProfileClick', 'appConfig.config']
            }
        });
    },
    reducer: reducer
});
export default store;
